<form [formGroup]="dynamicListForm" fxLayout="row" fxLayoutGap="20px">
  <div *ngFor="let input of data.inputs" >
    <mat-form-field class="select-field" *ngIf="input.display && !showLoader" color="accent">
      <mat-select [formControlName]="input.id" [placeholder]="input.placeholder | translate" (selectionChange)="onSelectionChange(input, dynamicListForm.get(input.id).value)">
        <mat-option [value]="option" *ngFor="let option of input.display">{{ option[input.selectByProperty] }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-progress-spinner *ngIf="showLoader && !input.parentListId" mode="indeterminate" [diameter]="20" color="accent"></mat-progress-spinner>
  </div>
</form>
